<template>
  <div>
    <header class="db-page-head">
      <div>
        <h2 class="db-page-title">Galerías</h2>
        <p class="db-page-subtitle">Crea álbumes de fotos y elige qué imágenes contiene cada uno.</p>
      </div>
      <div class="db-actions">
        <label v-if="lista.length > 6" class="db-search">
          <span class="material-symbols-outlined">search</span>
          <input v-model.trim="search" type="search" placeholder="Buscar galería…" aria-label="Buscar galería" />
        </label>
        <button type="button" class="db-btn" @click="nuevaGaleria">
          <span class="material-symbols-outlined">add</span> Nueva galería
        </button>
      </div>
    </header>

    <div v-if="loading" class="db-grid">
      <div v-for="n in 8" :key="n" class="db-skeleton" style="height: 250px"></div>
    </div>

    <div v-else class="db-grid">
      <button v-if="!search" type="button" class="db-add-card" @click="nuevaGaleria">
        <span class="material-symbols-outlined">add_photo_alternate</span>
        Nueva galería
      </button>
      <cardView
        v-for="item in filtrada"
        :key="item.id"
        :imageSrc="item.imagenGaleria"
        :imagetitle="item.titulo"
        :idGallery="item.id"
        @iconClick="actionGallery"
      />
    </div>

    <p v-if="!loading && search && !filtrada.length" class="db-empty">
      <span class="material-symbols-outlined">search_off</span>
      No hay galerías que coincidan con «{{ search }}».
    </p>

    <editGallery :dataGallery="gallerySelected" @updateGalerias="callReloadGallery" />
    <selectorImagenes :idGallery="idgallery" :multiSelect="true" id="selectorImagenEditGaleria" />
  </div>
</template>

<script>
import cardView from "@/components/dashboard/CardView.vue";
import axios from "@/directives/axios.js";
import editGallery from "@/components/galeria/EditGallery.vue";
import selectorImagenes from "@/components/dashboard/SelectorImages.vue";
import { confirmar, avisar, normalizar, avisarError } from "@/directives/dbDialogs.js";

export default {
  name: "createGallery",
  components: {
    cardView,
    editGallery,
    selectorImagenes,
  },
  data() {
    return {
      lista: [],
      loading: true,
      search: "",
      gallerySelected: null,
      idgallery: undefined,
    };
  },
  computed: {
    filtrada() {
      const q = normalizar(this.search);
      return q ? this.lista.filter((g) => normalizar(g.titulo).includes(q)) : this.lista;
    },
  },
  mounted() {
    this.callGallery();
  },
  methods: {
    callReloadGallery(value) {
      // De más nueva a más antigua (el id crece con cada galería creada)
      this.lista = [...(value || [])].sort((a, b) => Number(b.id) - Number(a.id));
    },
    async callGallery() {
      try {
        const { data } = await axios.get("/imagenes/todasGalerias");
        this.callReloadGallery(data.todasGalerias);
      } catch (error) {
        avisarError(this, error, "No se pudieron cargar las galerías.");
      } finally {
        this.loading = false;
      }
    },
    nuevaGaleria() {
      this.gallerySelected = { id: "0", tituloNoticia: "", imageSrc: "" };
      this.$nextTick(() => this.$bvModal.show("editGallery"));
    },
    actionGallery(value) {
      switch (value.action) {
        case "openGallery":
          this.idgallery = value.id;
          this.$nextTick(() => this.$bvModal.show("selectorImagenEditGaleria"));
          break;
        case "deleteGallery":
          this.deleteGallery(value);
          break;
        case "editGallery":
          this.gallerySelected = value;
          this.$nextTick(() => this.$bvModal.show("editGallery"));
          break;
        default:
          break;
      }
    },
    async deleteGallery(galeria) {
      const ok = await confirmar(this, `Se eliminará la galería «${galeria.tituloNoticia}» y todas sus fotos.`, {
        titulo: "Eliminar galería",
        ok: "Eliminar",
        peligro: true,
      });
      if (!ok) return;
      try {
        const { data } = await axios.delete(`/imagenes/eliminarGaleria?id=${galeria.id}`);
        this.callReloadGallery(data.todasGalerias);
        avisar(this, `Se ha eliminado la galería «${galeria.tituloNoticia}».`, "success", "Galería eliminada");
      } catch (error) {
        avisarError(this, error, "No se pudo eliminar la galería.");
      }
    },
  },
};
</script>
